/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, EventEmitter, OnDestroy, OnInit, Input, Output, ViewChild } from '@angular/core';
import {ClientProvider, ReportProvider} from '../../../../providers';
import {Client, Helpers, Zip} from 'src/app/model';
import { SearchableItem } from 'src/app/model/interface/searchable.item';
import { SearchableSelection } from 'src/app/model/interface/searchable.selection';
import { CrmAlertComponent } from 'src/app/components/fields';
import { PresetValue } from 'src/app/model/preset-value';

@Component({
  selector: 'page-client-edit',
  templateUrl: 'client-edit.page.html',
  styleUrls: ['client-edit.page.scss']
})
export class ClientEditPage implements OnInit, OnDestroy {
  @ViewChild('alert') alert: CrmAlertComponent;
  @Output() onCreate: EventEmitter<SearchableItem> = new EventEmitter();
  @Output() onCancel: EventEmitter<void> = new EventEmitter();
  @Input('edit') editFlag = false;
  @Input() compact = false;
  @Input() client: Client = new Client();

  stateItems: SearchableItem[] = [];

  zipError: string;
  zipLoading = false;
  lastCheckedZip: string;

  templateValues: SearchableItem[] = [
    PresetValue.create('Bryn Mawr Trust', 'engagement_letter_ds_bmt'),
    PresetValue.create('CIBC', 'engagement_letter_ds_cibc'),
    PresetValue.create('Citizens Bank', 'engagement_letter_ds_citizens_bank'),
    PresetValue.create('Enterprise Bank', 'engagement_letter_ds_enterprise_bank'),
    PresetValue.create('First Citizens Bank', 'engagement_letter_ds_first_citizen_bank'),
    PresetValue.create('First Tennessee Bank', 'engagement_letter_ds_first_tennessee_bank'),
    // PresetValue.create('Huntington Bank', 'engagement_letter_hb'),
    PresetValue.create('Wells Fargo Bank', 'engagement_letter_ds_well_fargo_bank'),
  ];

  constructor(
    public clientProvider: ClientProvider,
    private reportProvider: ReportProvider,
  ) {}

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.stateItems = Helpers.getDefaultStates();
  }

  onSubmit(): void {
    this.alert.hide();
    this.clientProvider.saveClient(this.client)
      .subscribe(data => {
        if (data.success) {
          this.onCreate.emit(Client.parse(data.result));
        } else {
          this.alert.show(data.error);
        }
      });
  }

  actionCancel(): void {
    this.onCancel.emit();
  }

  processPresetValue(value: SearchableSelection): void {
    if (value)
      this.client.STATE = value.VALUE;
    else this.client.STATE = null;
  }


  zipKeyPress(event: any): void {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar))
      event.preventDefault();
  }

  zipKeyUp(): void {
    if (this.client.ZIP == null)
      return;

    if (this.client.ZIP.length < 5) {
      this.client.CITY = '';
      this.client.STATE = '';
    }

    if (this.client.ZIP.length === 5 && !this.zipLoading) {
      this.zipLoading = true;
      this.zipError = null;
      this.lastCheckedZip = this.client.ZIP;

      this.reportProvider.identifyZip(this.client.ZIP)
        .subscribe(
          data => {
            this.zipLoading = false;

            if (data.success)
              if (data.result) {
                const zip = Zip.parse(data.result);

                if (zip) {
                  this.client.STATE = zip.STATE;
                  this.client.CITY = zip.CITY;
                } else {
                  this.zipError = 'Invalid Zip Code';
                  this.client.CITY = '';
                  this.client.STATE = '';
                }
              } else {
                this.zipError = 'Invalid Zip Code';
                this.client.CITY = '';
                this.client.STATE = '';
              }
          }, () => {
            this.zipLoading = false;
            this.zipError = 'Invalid Zip Code';
            this.client.CITY = '';
            this.client.STATE = '';
          });
    }
  }

  templateTypeChanged(value: SearchableSelection): void {
    this.client.TEMPLATE = value != null ? value.VALUE : null;
  }
}
